<div class="h-screen flex">
  <!-- Container that will always be in the center of the screen -->
  <div class="m-auto">
    <router-outlet></router-outlet>
  </div>
</div>
